"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=function(scopeFunc,params){var stylesObj={className:void 0,styles:void 0};if(params.options){var scope=scopeFunc(params);stylesObj={className:scope.props.className,styles:scope.props.children}}return stylesObj};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/__utils/resolveScopedStyles.js
// module id = 22
// module chunks = 0